// import analysisQyList from '../components/supervisionQy/analysisQyList.vue'
// import inspectQyList from '../components/supervisionQy/inspectQyList.vue'
// import punishQyList from '../components/supervisionQy/punishQyList.vue'
// import recordQyList from '../components/supervisionQy/recordQyList.vue'
// import supervisionQyList from '../components/supervisionQy/supervisionQyList.vue'
// import viewInspectQy from '../components/supervisionQy/viewInspectQy.vue'
// import addSupervision from '../components/supervisionQy/addSupervision.vue'
// import viewSupervision from '../components/supervisionQy/viewSupervision.vue'
// import rectificationList from '../components/supervisionQy/rectificationList.vue'

export default [
    { 
        path: 'supervisionQy/analysisQyList',
        component: resolve => require(['@/components/supervisionQy/analysisQyList'],resolve),
        name:'AnalysisQyList',
        meta:{
            id:'922',
            node:'supervisionQy',
            url:'analysisQyList',
        }
    },
    { 
        path: 'supervisionQy/inspectQyList',
        component: resolve => require(['@/components/supervisionQy/inspectQyList'],resolve),
        name:'InspectQyList',
        meta:{
            id:'914',
            node:'supervisionQy',
            url:'inspectQyList',
        }
    },
    { 
        path: 'supervisionQy/punishQyList',
        component: resolve => require(['@/components/supervisionQy/punishQyList'],resolve),
        name:'PunishQyList',
        meta:{
            id:'920',
            node:'supervisionQy',
            url:'punishQyList',
        }
    },
    { 
        path: 'supervisionQy/recordQyList',
        component: resolve => require(['@/components/supervisionQy/recordQyList'],resolve),
        name:'RecordQyList',
        meta:{
            id:'918',
            node:'supervisionQy',
            url:'recordQyList',
        }
    },
    { 
        path: 'supervisionQy/supervisionQyList',
        component: resolve => require(['@/components/supervisionQy/supervisionQyList'],resolve),
        name:'SupervisionQyList',
        meta:{
            id:'916',
            node:'supervisionQy',
            url:'supervisionQyList',
        }
    },
    { 
        path: 'supervisionQy/viewInspectQy',
        component: resolve => require(['@/components/supervisionQy/viewInspectQy'],resolve),
        name:'ViewInspectQy',
        meta:{
            // id:'914',
            node:'supervisionQy',
            url:'viewInspectQy',
        }
    },
    { 
        path: 'supervisionQy/addSupervision',
        component: resolve => require(['@/components/supervisionQy/addSupervision'],resolve),
        name:'AddSupervision',
        meta:{
            // id:'914',
            node:'supervisionQy',
            url:'addSupervision',
        }
    },
    { 
        path: 'supervisionQy/viewSupervision',
        component: resolve => require(['@/components/supervisionQy/viewSupervision'],resolve),
        name:'ViewSupervision',
        meta:{
            // id:'914',
            node:'supervisionQy',
            url:'viewSupervision',
        }
    },
    { 
        path: 'supervisionQy/rectificationList',
        component: resolve => require(['@/components/supervisionQy/rectificationList'],resolve),
        name:'RectificationList',
        meta:{
            id:'943',
            node:'supervisionQy',
            url:'rectificationList',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/supervisionQy.js